<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-user-plus"></i> {{title | translate}}</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="participantForm">
      <div class="form-row">
        <div class="col-md-6">
          <div class="row">
            <div class="col">
              <label class="font-weight-bold">{{ "LABEL.FLOW-TYPE" | translate }}
                :</label> {{ 'SELECT.OPTIONS.' + workflowtypeDesc |translate }}
            </div>
          </div>
          <div class="row">
            <div class="col">
              <label class="font-weight-bold">{{ "LABEL.DENOMINATION" | translate }}
                :</label> {{ workflowReceived.description }}
            </div>
          </div>
          <div [hidden]="!isNotFull">
            <div class="row">
              <div class="col">
                <label>{{ "LABEL.USER-TYPE" | translate }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mr-10">
                <div class="custom-control custom-radio">
                  <input type="radio"
                         id="addInvitadoRadio"
                         name="groupRadio"
                         class="custom-control-input"
                         [value]="1"
                         [(ngModel)]="participant.participantType"
                         (ngModelChange)="onItemChangeParticipantType();loadOperations();typeOperationChange()"
                         formControlName="groupRadio">
                  <label class="custom-control-label" for="addInvitadoRadio">{{ "LABEL.USER" | translate }}</label>
                </div>
              </div>
              <div class="col-md-5">
                <div class="custom-control custom-radio">
                  <input type="radio"
                         id="addPersonRadio"
                         name="groupRadio"
                         class="custom-control-input"
                         [value]="2"
                         [(ngModel)]="participant.participantType"
                         (ngModelChange)="onItemChangeParticipantType();loadOperations();typeOperationChange()"
                         formControlName="groupRadio">
                  <label class="custom-control-label"
                         for="addPersonRadio">{{ "LABEL.INVITED-USER" | translate }}</label>
                </div>
              </div>
              <div class="col-md-4"
                   [hidden]="isOptBatchLoadSelected || (this.hasSend2MailAfterUpload && !this.hasNotificateAfterUpload)"
                   *ngIf="hasAuthority('own:view:participant:10200')">
                <div class="custom-control custom-radio">
                  <input type="radio"
                         id="searchPersonRadio"
                         name="groupRadio"
                         class="custom-control-input"
                         [value]="3"
                         [(ngModel)]="participant.participantType"
                         (ngModelChange)="onItemChangeParticipantType();loadOperations();typeOperationChange()"
                         formControlName="groupRadio">
                  <label class="custom-control-label" for="searchPersonRadio">{{ "LABEL.INVITED" | translate }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 pr-3" [hidden]="!isNotFull">
          <div class="form-row">
            <div class="col-md-6">
              <div class="form-row" *ngIf="visualizationOperationSelected">
                <div class="custom-control custom-radio">
                  <input class="custom-control-input"
                         type="radio"
                         id="visualizationRadios"
                         formControlName="reviewOperation"
                         [(ngModel)]="participant.operationId"
                         [value]="VISUALIZATION">
                  <label class="custom-control-label" for="visualizationRadios">
                    {{ "LABEL.DOCUMENT-VISUALIZATION" | translate }}
                  </label>
                </div>
              </div>
              <div class="form-row" *ngIf="reviewOperationSelected">
                <div class="custom-control custom-radio">
                  <input class="custom-control-input"
                         type="radio"
                         id="reviewRadios"
                         formControlName="reviewOperation"
                         [(ngModel)]="participant.operationId"
                         [value]="REVIEW">
                  <label class="custom-control-label" for="reviewRadios">
                    {{ "LABEL.REVIEW-DOCUMENTS" | translate }}
                  </label>
                </div>
              </div>
              <div *ngIf="signatureOperationSelected">
                <a *ngIf="!isPresentAddManifestAndTraceability">
                  <fieldset class="fieldset">
                    <legend
                      class="custom-legend font-weight-bold"> {{ "LABEL.DIGITAL-SIGNATURES" | translate }}</legend>
                    <div class="form-row">
                      <div class="custom-control custom-radio">
                        <input class="custom-control-input"
                               type="radio"
                               id="digitalSignatureRadios"
                               formControlName="signOperation"
                               [(ngModel)]="participant.typeSignature"
                               [value]="DIGITAL_SIGNATURE"
                               (ngModelChange)="typeSignatureChange()">
                        <label class="custom-control-label" for="digitalSignatureRadios">
                          {{ "LABEL.DIGITAL-SIGNATURE" | translate }}
                        </label>
                      </div>
                    </div>
                    <div class="form-row" *ngIf="hasAuthority('own:view:participant:10201')">
                      <div class="custom-control custom-radio">
                        <input class="custom-control-input"
                               type="radio"
                               id="cloudSignatureRadios"
                               formControlName="signOperation"
                               [(ngModel)]="participant.typeSignature"
                               [value]="CLOUD_SIGNATURE"
                               (ngModelChange)="typeSignatureChange()">
                        <label class="custom-control-label" for="cloudSignatureRadios">
                          {{ "LABEL.ONESIGN-SIGNATURE" | translate }}
                        </label>
                      </div>
                    </div>
                    <div class="form-row" *ngIf="hasAuthority('own:view:participant:10202')">
                      <div class="custom-control custom-radio">
                        <input class="custom-control-input"
                               type="radio"
                               id="remoteSignatureRadios"
                               formControlName="signOperation"
                               [(ngModel)]="participant.typeSignature"
                               [value]="REMOTE_SIGNATURE"
                               (ngModelChange)="typeSignatureChange()">
                        <label class="custom-control-label" for="remoteSignatureRadios">
                          {{ "LABEL.REMOTE-SIGNATURE" | translate }}
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </a>
                <fieldset class="fieldset">
                  <legend
                    class="custom-legend font-weight-bold">  {{ "LABEL.ELECTRONICS-SIGNATURES" | translate }}</legend>
                  <div class="form-row">
                    <div class="custom-control custom-radio">
                      <input class="custom-control-input"
                             type="radio"
                             id="electronicSignatureRadios"
                             formControlName="signOperation"
                             [(ngModel)]="participant.typeSignature"
                             [value]="ELECTRONIC_SIGNATURE"
                             (ngModelChange)="typeSignatureChange()">
                      <label class="custom-control-label" for="electronicSignatureRadios">
                        {{ "LABEL.GRAPHIC-SIGNATURE" | translate }}
                      </label>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
            <!--            <div class="col-md-6" *ngIf="!visualizationOperationSelected">-->
            <div class="col-md-6">
              <div class="form-row" *ngIf="REMOTE_SIGNATURE !== participant.typeSignature">
                <div class="custom-control custom-checkbox my-1 mr-sm-2 mt-2">
                  <input type="checkbox"
                         class="custom-control-input"
                         id="addTsaCheckbox"
                         name="tsa"
                         [(ngModel)]="participant.addTsa"
                         (ngModelChange)="onItemChangeTsa($event)"
                         [attr.disabled]="CLOUD_SIGNATURE === participant.typeSignature ||
                          this.ELECTRONIC_SIGNATURE === this.participant.typeSignature ? '' : null"
                         formControlName="tsa">
                  <label class="custom-control-label" for="addTsaCheckbox">{{ "LABEL.TIMESTAMP" | translate }} <small>(TSA)</small></label>
                </div>
              </div>
              <div class="form-row">
                <div class="custom-control custom-checkbox my-1 mr-sm-2 mt-2">
                  <input type="checkbox"
                         class="custom-control-input"
                         id="sendAlertCheckbox_1"
                         name="sendAlert2"
                         [(ngModel)]="participant.sendAlert"
                         (ngModelChange)="onItemChangeSendAlert($event)"
                         formControlName="sendAlert"
                         [attr.disabled]="visualizationOperationSelected ? '' : null">
                  <label class="custom-control-label"
                         for="sendAlertCheckbox_1">{{ "LABEL.ALERT-BY-EMAIL" | translate }}</label>
                </div>
              </div>
              <div class="form-row">
                <div class="custom-control custom-checkbox my-1 mr-sm-2 mt-2">
                  <input type="checkbox"
                         class="custom-control-input"
                         id="sendWspAlertCheckbox_1"
                         name="sendWspAlert1"
                         [(ngModel)]="participant.sendWspAlert"
                         (ngModelChange)="onItemChangeSendWspAlert($event)"
                         formControlName="sendWspAlert">
                  <label class="custom-control-label"
                         for="sendWspAlertCheckbox_1">{{ "LABEL.ALERT-BY-WSP" | translate }}</label>
                </div>
              </div>
              <div class="form-row">
                <div class="custom-control custom-checkbox my-1 mr-sm-2 mt-2">
                  <input type="checkbox"
                         class="custom-control-input"
                         id="sendNotificationCheckbox3"
                         name="sendNotification"
                         [(ngModel)]="participant.sendNotification"
                         (ngModelChange)="onItemChangeSendNotification($event)"
                         [attr.disabled]="disableSendNotification ||
                         ELECTRONIC_SIGNATURE === participant.typeSignature ||
                         visualizationOperationSelected ? '' : null"
                         formControlName="sendNotification">
                  <label class="custom-control-label"
                         for="sendNotificationCheckbox3">{{ "LABEL.NOTIFY-ELECTRONICALLY" | translate }}</label>
                </div>
              </div>
              <div class="form-row" *ngIf="REMOTE_SIGNATURE === participant.typeSignature">
                <div class="custom-control custom-select-signature-level">
                  <label for="uanatacasignaturelevel">{{ "LABEL.SIGNATURE-LEVEL" | translate }}:</label>
                  <select class="form-control"
                          id="uanatacasignaturelevel"
                          formControlName="uanatacasignaturelevel"
                          [(ngModel)]="participant.signatureLevel">
                    <option *ngFor="let uanatacasignaturelevel of uanatacasignaturelevels"
                            [ngValue]="uanatacasignaturelevel.id">{{'SELECT.OPTIONS.' + uanatacasignaturelevel.name | translate}}</option>
                  </select>
                </div>
              </div>
              <div class="form-row"
                   *ngIf="SIGNATURE_WORKFLOW === workflowReceived.type || signatureOperationSelected">
                <div class="custom-control custom-checkbox my-1 mr-sm-2 mt-2">
                  <input type="checkbox"
                         class="custom-control-input"
                         id="dragRubric"
                         name="dragRubric"
                         [(ngModel)]="participant.dragRubric"
                         (ngModelChange)="onItemChangeDragRubric($event)"
                         formControlName="dragRubric">
                  <label class="custom-control-label" for="dragRubric">{{ "LABEL.RUBRIC-DRAGGING" | translate }}</label>
                </div>
              </div>
              <div class="form-row"
                   *ngIf="SIGNATURE_WORKFLOW === workflowReceived.type || signatureOperationSelected">
                <div class="custom-control custom-checkbox my-1 mr-sm-2 mt-2">
                  <input type="checkbox"
                         class="custom-control-input"
                         id="acceptRubricPlacement"
                         name="acceptRubricPlacement"
                         [(ngModel)]="participant.acceptRubricPlacement"
                         (ngModelChange)="onItemChangeAcceptRubricPlacement($event)"
                         formControlName="acceptRubricPlacement"
                         [attr.disabled]="!this.participant.dragRubric ? true: null">
                  <label class="custom-control-label"
                         for="acceptRubricPlacement">{{ "LABEL.ACCEPT-RUBRIC-PLACEMENT" | translate }}</label>
                </div>
              </div>
              <div class="form-row"
                   *ngIf="ELECTRONIC_SIGNATURE === participant.typeSignature && !isFreelySignature(this.workflowReceived) && signatureOperationSelected">
                <div class="custom-control custom-checkbox my-1 mr-sm-2 mt-2">
                  <input type="checkbox"
                         class="custom-control-input"
                         id="identityValidation"
                         name="identityValidation"
                         [(ngModel)]="participant.identityValidation"
                         (ngModelChange)="onItemChangeIdentityValidation($event)"
                         formControlName="identityValidation">
                  <label class="custom-control-label"
                         for="identityValidation">{{ "LABEL.IDENTITY-VALIDATION" | translate }}</label>
                </div>
              </div>
              <div class="form-row"
                   *ngIf="SIGNATURE_WORKFLOW === workflowReceived.type && !isFreelySignature(this.workflowReceived)">
                <div class="custom-control custom-checkbox my-1 mr-sm-2 mt-2">
                  <input type="checkbox"
                         class="custom-control-input"
                         id="documentTracking"
                         name="documentTracking"
                         [(ngModel)]="participant.documentTracking"
                         (ngModelChange)="onItemChangeDocumentTracking($event)"
                         formControlName="documentTracking">
                  <label class="custom-control-label"
                         for="documentTracking">{{ "LABEL.DOCUMENT-TRACKING" | translate }}</label>
                </div>
              </div>
              <div class="form-row"
                   *ngIf="ELECTRONIC_SIGNATURE === participant.typeSignature && !isFreelySignature(this.workflowReceived)">
                <div class="custom-control custom-checkbox my-1 mr-sm-2 mt-2">
                  <input type="checkbox"
                         class="custom-control-input"
                         id="documentIntegrity"
                         name="documentIntegrity"
                         [(ngModel)]="participant.documentIntegrity"
                         (ngModelChange)="onItemChangeDocumentIntegrity($event)"
                         formControlName="documentIntegrity">
                  <label class="custom-control-label"
                         for="documentIntegrity">{{ "LABEL.DOCUMENT-INTEGRITY" | translate }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2" [hidden]="!isNotFull">
        <div class="col-md-2">
          <label for="operationType">{{ "LABEL.T-OPERATION" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fas fa-plus-square"></i></div>
            </div>
            <select id="operationType"
                    class="form-control"
                    formControlName="operation"
                    [(ngModel)]="participant.operationId"
                    [class.is-invalid]="isInvalidControl('operation')"
                    (change)="typeOperationChange()">
              <option *ngFor="let operation of operations"
                      [ngValue]="operation.id">{{operation.description | translate}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-5" [hidden]="isInvited">
          <label for="nombre">{{ "LABEL.PARTICIPANT-NAME" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fas fa-keyboard"></i></div>
            </div>
            <input class="form-control"
                   id="nombre"
                   [(ngModel)]="personFullName"
                   (keyup)="search($event)"
                   (change)="onPersonChanged(personFullName)"
                   formControlName="personName"
                   placeholder="{{ 'MESSAGE.ENTER-PERSON-DATA' | translate }}"
                   autocomplete="off"
                   list="peopleList">
            <datalist id="peopleList" *ngIf="people">
              <option *ngFor="let person of this.people" [ngValue]="person">
                {{person.documentNumber}} - {{person.fullname | translate}} - {{person._more.jobDescription}}
              </option>
            </datalist>
          </div>
          <small *ngIf="isInvalidControl('personName')"
                 class="text-danger">
            {{ "MESSAGE.ENTER-PARTICIPANT-NAME" | translate }}
          </small>
        </div>
        <div class="col-md-2 mt-4">
          <div class="justify-content-end mt-2">
            <button class="btn btn-success"
                    (click)="addParticipant()"
                    [disabled]="participantForm.invalid || !isNotFull || !wasSelectedPersonAfterSearch"> +
              {{ "BUTTON.ADD" | translate }}
            </button>
          </div>
        </div>
      </div>
      <div class="mt-2" *ngIf="wasSelectedPersonAfterSearch && !isInvited">
        <div class="row">
          <div class="col">
            <label><b>DNI: </b> {{selectedPerson.documentNumber}}</label>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label><b>{{ "LABEL.JOB" | translate }}: </b> {{selectedPerson | jobDescription }}</label>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label><b>{{ "LABEL.ENTERPRISE" | translate }}: </b> {{selectedPerson | enterpriseName}}</label>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <div class="table-responsive custom-table-height">
            <table class="table-sm table-bordered">
              <thead>
              <tr>
                <!--                <th scope="col" rowspan="2" title="#"></th>-->
                <th scope="col" rowspan="2" title="{{ 'TABLE.HEADER.PARTICIPANT' | translate }}"></th>
                <th scope="col" rowspan="2" title="{{ 'TABLE.HEADER.OPERATION' | translate }}"></th>
                <th scope="col" rowspan="2" title="{{ 'TABLE.HEADER.ORDER' | translate }}"></th>
                <th scope="col" rowspan="2" title="TSA"></th>
                <th scope="col" colspan="2" title="{{ 'TABLE.HEADER.ALERT' | translate }}"></th>
                <th scope="col" rowspan="2" title="{{ 'TABLE.HEADER.NOTIFY' | translate }}"></th>
                <th scope="col" colspan="2" title="{{ 'TABLE.HEADER.AFTER-FINISHING-SEND' | translate }}"></th>
                <th scope="col" rowspan="2" title="{{ 'TABLE.HEADER.SIGNATURE-TYPE' | translate }}"></th>
                <th scope="col" rowspan="2" title="{{ 'TABLE.HEADER.SIGNATURE-LEVEL' | translate }}"></th>
                <th scope="col" rowspan="2" title="{{ 'TABLE.HEADER.RUBRIC-DRAGGING' | translate }}"></th>
                <th scope="col" rowspan="2" title="{{ 'TABLE.HEADER.ACCEPT-LOCATION' | translate }}"></th>
                <th scope="col" rowspan="2" title="{{ 'TABLE.HEADER.IDENTITY-VALIDATION' | translate }}"></th>
                <th scope="col" rowspan="2" title="{{ 'TABLE.HEADER.DOCUMENT-TRACKING' | translate }}"></th>
                <th scope="col" rowspan="2" title="{{ 'TABLE.HEADER.DOCUMENT-INTEGRITY' | translate }}"></th>
                <th scope="col" rowspan="2" title="{{ 'TABLE.HEADER.ACTION' | translate }}"></th>
              </tr>
              <tr>
                <th title="{{ 'TABLE.HEADER.EMAIL' | translate }}"></th>
                <th title="{{ 'TABLE.HEADER.WHATSAPP' | translate }}"></th>
                <th title="{{ 'TABLE.HEADER.MAIL' | translate }}"></th>
                <th title="{{ 'TABLE.HEADER.DOMICILE' | translate }}"></th>
              </tr>
              </thead>
              <tbody cdkDropList (cdkDropListDropped)="drop($event)" formArrayName="arrayParticipant">
              <tr *ngFor="let group of arrayParticipant.controls; let index=index" [formGroupName]="index"
                  cdkDrag
                  [cdkDragData]="group">
                <!--                <td class="font-weight-bold" title="#">-->
                <!--                  {{index + 1}}-->
                <!--                </td>-->
                <td title="{{ 'TABLE.HEADER.PARTICIPANT' | translate }}">{{group.get('personFullname').value}}</td>
                <td title="{{ 'TABLE.HEADER.OPERATION' | translate }}">
                  <span class="badge {{getBadgeTypeBy(group.get('operationId').value)}}">
                    {{getOperationDescription(group.get('operationId').value) | translate}}
                  </span>
                </td>
                <td title="{{ 'TABLE.HEADER.ORDER' | translate }}">{{ index + 1 }}</td>
                <td title="TSA">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox"
                           class="custom-control-input"
                           id="tsaCheckbox{{index}}"
                           formControlName="addTsa"
                           [attr.disabled]="REVIEW === group.get('operationId').value ||
                              CLOUD_SIGNATURE === group.get('typeSignature').value ||
                              REMOTE_SIGNATURE === group.get('typeSignature').value ||
                              ELECTRONIC_SIGNATURE === group.get('typeSignature').value ? '' : null">
                    <label class="custom-control-label" for="tsaCheckbox{{index}}"></label>
                  </div>
                </td>
                <td title="{{ 'TABLE.HEADER.ALERT' | translate }} {{ 'TABLE.HEADER.EMAIL' | translate }}">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox"
                           class="custom-control-input"
                           id="sendAlertCheckbox{{index}}"
                           formControlName="sendAlert"
                           [attr.disabled]="VISUALIZATION === group.get('operationId').value || this.workflowReceived.notifyAfterUpload ? '' : null">
                    <label class="custom-control-label" for="sendAlertCheckbox{{index}}"></label>
                  </div>
                </td>
                <td title="{{ 'TABLE.HEADER.ALERT' | translate }} {{ 'TABLE.HEADER.WHATSAPP' | translate }}">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox"
                           class="custom-control-input"
                           id="sendWspAlertCheckbox{{index}}"
                           formControlName="sendWspAlert">
                    <label class="custom-control-label" for="sendWspAlertCheckbox{{index}}"></label>
                  </div>
                </td>
                <td title="{{ 'TABLE.HEADER.NOTIFY' | translate }}">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox"
                           class="custom-control-input"
                           id="sendNotificationCheckbox{{index}}"
                           formControlName="sendNotification"
                           [attr.disabled]="onlySignOption ||
                              VISUALIZATION === group.get('operationId').value ? '' : null">
                    <label class="custom-control-label" for="sendNotificationCheckbox{{index}}"></label>
                  </div>
                </td>
                <td title="{{ 'TABLE.HEADER.AFTER-FINISHING-SEND' | translate }} {{ 'TABLE.HEADER.MAIL' | translate }}">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox"
                           class="custom-control-input"
                           id="sendCompletionEmailCheckbox{{index}}"
                           formControlName="sendCompletionEmail"
                           [attr.disabled]="!this.hasNotificationByDocument ? '' : null">
                    <label class="custom-control-label" for="sendCompletionEmailCheckbox{{index}}"></label>
                  </div>
                </td>
                <td
                  title="{{ 'TABLE.HEADER.AFTER-FINISHING-SEND' | translate }} {{ 'TABLE.HEADER.DOMICILE' | translate }}">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox"
                           class="custom-control-input"
                           id="sendCompletionNotificationCheckbox{{index}}"
                           formControlName="sendCompletionNotification"
                           [attr.disabled]="!this.hasNotificationByDocument ? '' : null">
                    <label class="custom-control-label" for="sendCompletionNotificationCheckbox{{index}}"></label>
                  </div>
                </td>
                <td title="{{ 'TABLE.HEADER.SIGNATURE-TYPE' | translate }}">
                  {{description(group.get('typeSignature').value)}}
                </td>
                <td title="{{ 'TABLE.HEADER.SIGNATURE-LEVEL' | translate }}">
                  {{descriptionOfSignatureLevel(group.get('signatureLevel').value) | translate}}
                </td>
                <td title="{{ 'TABLE.HEADER.RUBRIC-DRAGGING' | translate }}">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox"
                           class="custom-control-input"
                           id="dragRubric{{index}}"
                           formControlName="dragRubric"
                           [attr.disabled]="REVIEW === group.get('operationId').value ||
                              (SIGNATURE_WORKFLOW !== workflowReceived.type &&
                              UPLOAD_TO_IOFESIGN !== workflowReceived.type) ||
                              VISUALIZATION === group.get('operationId').value ? '' :
                              NOTIFY === group.get('operationId').value ? '' : null">
                    <label class="custom-control-label" for="dragRubric{{index}}"></label>
                  </div>
                </td>
                <td title="{{ 'TABLE.HEADER.ACCEPT-LOCATION' | translate }}">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox"
                           class="custom-control-input"
                           id="acceptRubricPlacement{{index}}"
                           formControlName="acceptRubricPlacement"
                           [attr.disabled]="REVIEW === group.get('operationId').value ||
                              (SIGNATURE_WORKFLOW !== workflowReceived.type &&
                              UPLOAD_TO_IOFESIGN !== workflowReceived.type) ||
                              !group.get('dragRubric').value ||
                              VISUALIZATION === group.get('operationId').value ? '' :
                              NOTIFY === group.get('operationId').value ? '' : null">
                    <label class="custom-control-label" for="acceptRubricPlacement{{index}}"></label>
                  </div>
                </td>

                <td title="{{ 'TABLE.HEADER.IDENTITY-VALIDATION' | translate }}">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox"
                           class="custom-control-input"
                           id="identityValidation{{index}}"
                           formControlName="identityValidation"
                           [attr.disabled]="REVIEW === group.get('operationId').value ||
                              (SIGNATURE_WORKFLOW !== workflowReceived.type &&
                              UPLOAD_TO_IOFESIGN !== workflowReceived.type) ||
                              VISUALIZATION === group.get('operationId').value ? '' :
                              NOTIFY === group.get('operationId').value ? '' : null
                              || ELECTRONIC_SIGNATURE !== group.get('typeSignature').value ? '' : null">
                    <label class="custom-control-label" for="identityValidation{{index}}"></label>
                  </div>
                </td>
                <td title="{{ 'TABLE.HEADER.DOCUMENT-TRACKING' | translate }}">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox"
                           class="custom-control-input"
                           id="documentTracking{{index}}"
                           formControlName="documentTracking"
                           [attr.disabled]="SIGNATURE_WORKFLOW !== workflowReceived.type ||
                              isFreelySignature(this.workflowReceived) ||
                              VISUALIZATION === group.get('operationId').value ? '' : null">
                    <label class="custom-control-label" for="documentTracking{{index}}"></label>
                  </div>
                </td>
                <td title="{{ 'TABLE.HEADER.DOCUMENT-INTEGRITY' | translate }}">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox"
                           class="custom-control-input"
                           id="documentIntegrity{{index}}"
                           formControlName="documentIntegrity"
                           [attr.disabled]="ELECTRONIC_SIGNATURE !== group.get('typeSignature').value ? '' : null">
                    <label class="custom-control-label" for="documentIntegrity{{index}}"></label>
                  </div>
                </td>
                <td title="{{ 'TABLE.HEADER.ACTION' | translate }}">
                  <div class="dropdown">
                    <button type="button" class="btn btn-default " id="dropdownMenuButton"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i class="fa fa-ellipsis-v"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <button class="dropdown-item pointer"
                              *ngIf="viewSendNotificationOpt(group.get('sendNotification').value) && hasAuthority('own:sie:add:mailbody:participant')"
                              (click)="openModalNotifyPostOperation(group.get('id').value)">
                        <i class="fa fa-envelope"></i> {{ "BUTTON.NOTIFY-POST-OPERATION" | translate }}
                      </button>
                      <button class="dropdown-item pointer" (click)="delete(index)">
                        <i class="fa fa-trash"></i> {{ "BUTTON.DELETE" | translate }}
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" [disabled]="hasnotMiniumParticipants"
            (click)="save()">
      <i class="fa fa-bookmark"></i>  {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger"
            (click)="cancel()">
      <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
